// extracted by mini-css-extract-plugin
export default {"search-input-container":"SearchInputV1_search-input-container__NjGGl","search-input":"SearchInputV1_search-input__3t1o0","search-icon":"SearchInputV1_search-icon__hovk7"};